<app-base-modal
  [open]="open"
  (openChange)="openChange.emit($event)"
  (closed)="close()"
  title="Edit group"
  size="md"
>
  <form class="space-y-4" [formGroup]="editForm" (ngSubmit)="save()">
    <div>
      <label for="groupName" class="mb-1 block text-sm font-medium text-gray-700">Name</label>
      <input
        id="groupName"
        type="text"
        formControlName="name"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
      />
      @if (submitted && editForm.controls.name.errors?.required) {
        <small class="text-sm text-red-600">Name is required.</small>
      }
    </div>

    <div>
      <label for="groupDescription" class="mb-1 block text-sm font-medium text-gray-700"
        >Description</label
      >
      <textarea
        id="groupDescription"
        rows="4"
        formControlName="description"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
      ></textarea>
      <p class="mt-1 text-xs text-gray-500">Optional short description for the group.</p>
    </div>

    <div class="rounded-xl border border-slate-200 bg-slate-50 p-4">
      <div class="flex items-center justify-between gap-4">
        <div>
          <p class="text-sm font-semibold text-gray-900">Group invite link</p>
          <p class="mt-1 text-xs text-gray-600">Allow other users to request to join this group</p>
        </div>
        <label class="relative inline-flex cursor-pointer items-center">
          <input type="checkbox" formControlName="inviteActive" class="peer sr-only" />
          <div
            class="peer h-6 w-11 rounded-full border-2 border-slate-300 bg-gray-300 transition-all peer-checked:border-secondary peer-checked:bg-secondary"
          ></div>
          <span
            class="absolute left-1 top-1 h-4 w-4 rounded-full bg-white transition-all peer-checked:left-6"
          ></span>
        </label>
      </div>
    </div>

    @if (errorMessage) {
      <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    }

    <div class="flex items-center justify-between gap-2 pt-2">
      <button
        type="button"
        class="rounded-lg border border-red-200 bg-white px-4 py-2 text-sm font-semibold text-red-600 transition-colors hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-70"
        (click)="askDelete()"
        [disabled]="saving || deleting"
      >
        Delete
      </button>

      <div class="flex justify-end gap-2">
        <button
          type="button"
          class="rounded-lg bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-70"
          (click)="close()"
          [disabled]="saving || deleting"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-hover disabled:cursor-not-allowed disabled:opacity-70"
          [disabled]="saving || deleting"
        >
          {{ saving ? 'Saving...' : 'Save changes' }}
        </button>
      </div>
    </div>
  </form>

  <app-confirm-modal
    [open]="showDeleteConfirm"
    [title]="'Delete group'"
    [message]="deleteConfirmMessage"
    [confirmText]="'Delete group'"
    [cancelText]="'Keep group'"
    [confirmVariant]="'danger'"
    [loading]="deleting"
    size="sm"
    (openChange)="showDeleteConfirm = $event"
    (confirmed)="confirmDelete()"
    (canceled)="cancelDelete()"
  ></app-confirm-modal>
</app-base-modal>
